/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_SupportInputs */

const en_admin_nav_support = /** @type {(inputs: Admin_Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const zh_admin_nav_support = /** @type {(inputs: Admin_Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户支持`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Admin_Nav_SupportInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_support = /** @type {((inputs?: Admin_Nav_SupportInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_SupportInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_support(inputs)
	return zh_admin_nav_support(inputs)
});
export { admin_nav_support as "admin.nav.support" }